<template>
    <v-card 
        class="pa-3" 
        style="border-radius: 8px;"
        >
        <v-card-title class="text-subtitle-1">Angemeldet als:</v-card-title>
        <v-card-title class="text-h6 mt-n5">{{ accCardUser }}</v-card-title>
        <v-btn 
            prepend-icon="mdi-key"
            type="submit" 
            color="grey" 
            class="mt-4" 
            block 
            :to="'/PasswordChange'" 
            link>
            Passwort ändern
        </v-btn>
        <v-btn 
            prepend-icon="mdi-logout" 
            type="submit" 
            color="grey" 
            class="mt-4" 
            block 
            @click="logout">
            Logout
        </v-btn>
      </v-card>
</template>

<script>
export default{
    data(){
        return{
            accCardUser: 'Kein Benutzer angemeldet'
        }
    },
    mounted(){
        this.getUser();
    },
    methods: {
        async getUser(){
            const response = await this.$axios.get('/api/users/') 
            this.accCardUser = response.data.current_user_firstname + " " + response.data.current_user_lastname
        },

        logout() {
            console.log("Logout: Token vorher:", localStorage.getItem('access_token'))

            localStorage.removeItem('access_token')
            delete this.$axios.defaults.headers.common['Authorization']

            console.log("Logout: Token nachher:", localStorage.getItem('access_token'))

            this.$router.push({ name: 'Auth' })
        }
    }
}
</script>